// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/Home/components/ResultModal.scss
// module id = 1248
// module chunks = 0